import {barnManagerModule} from '../index.module';

barnManagerModule
  .factory('rOnboarding', ['$resource', ($resource) => {
    return $resource('/api/barnmanager', {}, {});
  }]);
